<template>
    <div class="lo aside" :class="[asideState? 'is-active': '', showNav? 'is-show': '' ]">
        <mdToggleAside
            :state="asideState"
            
            @sendEvent="receiveEvent"
        ></mdToggleAside>
        <transition name="animate">
            <div class="g aside">
                <slot></slot>
            </div>
        </transition>
    </div>
</template>

<script>
    import mdToggleAside from '@/components/mdToggleAside'

    import { mapState } from 'vuex'

    export default {
        components: {
            mdToggleAside,
        },
        props: {
            caption: {
                type: String,
                required: false,
                default: '標題'
            }
        },
        data: function(){
            
            return {
                asideState: false
            }
        },
        computed: {
            ...mapState([
                'showNav',
            ]),
        },
        methods: {
            changeState: function(){
                this.asideState = !this.asideState
            }
        }
    }
</script>

<style scoped lang="scss">

    .animate-enter-active {
        animation: animate-in 150ms;
    }

    .animate-leave-active {
        animation: animate-out 150ms;
    }

    @keyframes animate-in {
        0% {
            transform: scale(1.1);
            opacity: 0;
        }

        100% {
            transform: scale(1);
            opacity: 1;
        }
    }

    @keyframes animate-out {
        0% {
            opacity: 1;
        }

        100% {
            opacity: 0;
        }
    }

    .lo.aside {
        $w: 200px;

        width: 0;
        overflow: hidden;

        @include media('mobile') {
            width: $w;
        }

        &.is-show {
            width: $w;

            .g.aside {
                opacity: 1;
            }
        }

        position: relative;
        flex-grow: 0;
        flex-shrink: 0;
        transition: $transition;

        @include media('mobile') {
            width: auto;
            margin-right: 0;
            z-index: 7;
        }

        &.is-active {

            .g.aside {
        
                @include media('mobile') {
                    left: 0;
                }
            }
        }

        .g.aside {
            opacity: 0;
            width: $w;
            transition: $transition;
            padding-top: $interval-m;
        
            @include media('mobile') {
                opacity: 1;
            }
    
            @include media('mobile') {
                position: fixed;
                top: 0;
                // width: calc(100vw - 100px);
                width: 75%;
                height: 100vh;
                left: -100vw;
                background-color: $forth-color;
                z-index: 1;
                overflow-y: auto;
                padding: $interval-l;
                box-sizing: border-box;
            }
        }
    }

</style>
